// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"6b43f127","434":"582e470c","729":"40de96bc"}[chunkId] + ".chunk.css";
};